<template lang="pug">
    .usp-info(:style="{height: height}")
      template(v-if="!showDefaultUsp")
        .head
          .close-button(@click="onCloseClick",
            ga-category="scene",
            ga-label="usp close")
        .media-content(v-if="carModel === 'jetta'")
          .image(v-if="uspData && uspData.pointName === 'trunk'", :style="{backgroundImage: `url('/usp-jetta/camera.png')`}")
          .image(v-if="uspData && uspData.pointName === 'lights'", :style="{backgroundImage: `url('/usp-jetta/lights.png')`}")
          .image(v-if="uspData && uspData.pointName === 'door'", :style="{backgroundImage: `url('/usp-jetta/kessy.png')`}")
          .image(v-if="uspData && uspData.pointName === 'adaptive-cruise'", :style="{backgroundImage: `url('/usp-jetta/cruise.png')`}")
          .image(v-if="uspData && uspData.pointName === 'distation-system'", :style="{backgroundImage: `url('/usp-jetta/front-assist.png')`}")
          .image(v-if="uspData && uspData.pointName === 'roof'", :style="{backgroundImage: `url('/usp-jetta/roof.png')`}")
          .image(v-if="uspData && uspData.pointName === 'wheel-seats'", :style="{backgroundImage: `url('/usp-jetta/wheel.png')`}")
          .image(v-if="uspData && uspData.pointName === 'interior'", :style="{backgroundImage: `url('/usp-jetta/interior.png')`}")
          .image(v-if="uspData && uspData.pointName === 'hud'", :style="{backgroundImage: `url('/usp-jetta/hud.jpg')`}")
          .image(v-if="uspData && uspData.pointName === 'app-connect'", :style="{backgroundImage: `url('/usp-jetta/multimedia.png')`}")
          .image(v-if="uspData && uspData.pointName === 'ambient-light'", :style="{backgroundImage: `url('/usp-jetta/ambient-light.png')`}")
        .media-content(v-else)
          .image(v-if="uspData && uspData.pointName === 'trunk'", :style="{backgroundImage: `url('/usp-polo/trunk.png')`}")
          .image(v-if="uspData && uspData.pointName === 'lights'", :style="{backgroundImage: `url('/usp-polo/lights.png')`}")
          .image(v-if="uspData && uspData.pointName === 'door'", :style="{backgroundImage: `url('/usp-polo/Kessy.png')`}")
          .image(v-if="uspData && uspData.pointName === 'light-sensors'", :style="{backgroundImage: `url('/usp-polo/light-sensors.png')`}")
          .image(v-if="uspData && uspData.pointName === 'parking'", :style="{backgroundImage: `url('/usp-polo/parking.png')`}")
          .image(v-if="uspData && uspData.pointName === 'back-lights'", :style="{backgroundImage: `url('/usp-polo/back-lights.png')`}")
          .image(v-if="uspData && uspData.pointName === 'camera'", :style="{backgroundImage: `url('/usp-polo/camera.png')`}")
          .image(v-if="uspData && uspData.pointName === 'hud'", :style="{backgroundImage: `url('/usp-polo/hud.png')`}")
          .image(v-if="uspData && uspData.pointName === 'interior'", :style="{backgroundImage: `url('/usp-polo/interior.png')`}")
          .image(v-if="uspData && uspData.pointName === 'multimedia'", :style="{backgroundImage: `url('/usp-polo/multimedia.png')`}")
        .text-wrapper
          .title {{uspData.title ? uspData.title : ''}}
          .text {{uspData.text}}
          .text(v-if="uspData.subText") {{uspData.subText}}
      template(v-else)
        .default-usp
          .title(v-if="this.isMobile") Добро пожаловать в <br/>3D-шоурум <span>Volkswagen {{this.carTitle}}</span>
          .info Нажимайте на стрелки ниже, чтобы ознакомиться с некоторыми преимуществами нового Volkswagen {{this.carTitle}}
          .instructions
            .instruction-item
              .icon.trunk
              .text открыть багажник
            .instruction-item
              .icon.doors
              .text открыть двери
            .instruction-item
              .icon.lights
              .text включить фары
            .instruction-item
              .icon.usp
              .text просмотр преимуществ
            .instruction-item
              .icon.color
              .text поменять цвет кузова
            .instruction-item(v-if="carModel === 'jetta'")
              .icon.seat
              .text поменять обивку салона
            .instruction-item(v-if="carModel === 'polo'")
              .icon.wheels
              .text поменять диски
          .car-info В 3D-шоуруме представлен автомобиль Volkswagen {{this.carTitle}} в комплектации {{this.carModel === 'jetta' ? 'Status' : 'Exclusive'}}
</template>
<script>
import isMobileMixin from "../mixins/isMobileMixin";
import {mapActions, mapGetters} from "vuex";

export default {
  mixins: [isMobileMixin],
  name: 'USPInfo',
  props: ['height', 'showDefaultUsp'],
  data() {
    return {
        defaultUsp: {
          title: 'Камера заднего вида',
          text: 'Новая Jetta оборудована камерой заднего вида для помощи при парковке.',
          pointName: 'trunk'
        },
    }
  },

  mounted() {
  },

  computed: {
    ...mapGetters(['uspData', 'carModel']),
    carTitle() {
      return this.carModel === 'jetta' ? 'Jetta' : 'Polo'
    },
    resultData() {
      return this.showDefaultUsp ?  this.defaultUsp : this.uspData
    }
  },
  methods: {
    ...mapActions(['hideUspWindow']),

    onCloseClick() {
      this.hideUspWindow()
    }
  }
}
</script>
